<template>
  <div
    id="detail"
    :class="{
      h5: this.$store.state.webType === 'h5',
      en: this.$store.state.lang === 'EN',
    }"
  >
    <el-row :span="24" class="page">
      <!-- 面包屑 -->
      <!--        <el-breadcrumb-item>{{ $t('sections') }}</el-breadcrumb-item>-->
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t("home") }} </el-breadcrumb-item>

        <el-breadcrumb-item :to="{ path: detail.path }">{{ detail.lmName }} </el-breadcrumb-item>
      </el-breadcrumb> -->
      <el-row :span="24" class="page-content">
        <div class="detail_content_box">
          <div class="detail_title">
            {{ detail.title }}
          </div>
          <div class="detail_time">
            <span>{{ detail.time }}</span>
            <span>Resource：{{ detail.source }}</span>
          </div>
          <div class="detail_content_info" v-html="detail.content"></div>
        </div>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import goTop from "../components/goTop";
import NewBook from "@/components/NewBook";
import HotArticle from "@/components/HotArticle";

export default {
  name: "ArticleDetail",
  components: {
    goTop,
    HotArticle,
    NewBook,
  },
  data() {
    return {
      currentView: "img",
      bannerData: [],
      bookData: {},
      articleData: [],
      // 文章列表
      artData: [],
      // 文章总数量
      listTotal: 0,
      maxPage: 1,
      // 文章列表请求信息
      listQuery: {
        nId: "",
      },
      detail: {},
    };
  },
  watch: {
    "$route.query.id"(value, oldValue) {
      // 第一个参数为新值，第二个参数为旧值，不能调换顺序
      // console.log(`新值：${value}`);
      // console.log(`旧值：${oldValue}`);
      this.listQuery.id = value;
      this.getDetail();
    },
  },
  mounted() {
    this.listQuery.nId = this.$route.query.id;
    this.getDetail();
    //  console.log(this.$store.state.lang);
  },
  methods: {
    getDetail() {
      this.$get(this.$api + "/un/webarticle/getInfo", this.listQuery).then(
        (res) => {
          this.detail = res.data;
          if (res.data.title) {
            document.title = `WFUCA-${res.data.title}`;
          }
          this.$nextTick(() => {
            let fontList = document.querySelectorAll(`font`);
            let pList = document.querySelectorAll(`p`);
            // console.log(fontList);
            pList.forEach((p) => {
              if (p.innerHTML == "") {
                //  console.log(p.innerHTML);
                p.style.height = "20px";
              }
            });
            fontList.forEach((item) => {
              if (item.parentNode.align === "center") {
                // console.log(item.parentNode.align);
                item.style.textAlign = "center";
                item.style.display = "block";
                item.style.textIndent = "0";
              }
            });
          });
          return;
          this.$nextTick(() => {
            // var ul = document.querySelector(`ul`) ;
            // var aTop = window.getComputedStyle(ul,"after").top;
            let page = document.querySelector(`.page`);
            let pageAfter = window.getComputedStyle(page, "after");
            let style = document.createElement("style");

            switch (this.detail.path) {
              case "/exclusive":
                style.innerHTML = `#app #detail .page::after{background-image: url('${require("../assets/images/djfb-bg.jpg")}');}`;
                break;
              case "/imgnumsay":
                style.innerHTML = `#app #detail .page::after{background-image: url('${require("../assets/images/say-bg.png")}');}`;
                break;
              case "/china":
                style.innerHTML = `#app #detail .page::after{background-image: url('${require("../assets/images/ddzg-bg.jpg")}');}`;
                break;
              case "/story":
                style.innerHTML = `#app #detail .page::after{background-image: url('${require("../assets/images/rwgs-bg.png")}');}`;
                break;
              case "/beautiful":
                style.innerHTML = `#app #detail .page::after{background-image: url('${require("../assets/images/zhzm-bg.jpg")}');}`;
                break;
              case "/wuzhou":
                style.innerHTML = `#app #detail .page::after{background-image: url('${require("../assets/images/wzyy-bg.jpg")}');}`;
                break;
            }
            document.head.appendChild(style);
            // console.log(pageAfter.backgroundImage);
            let list = document
              .querySelector(".detail-html")
              .querySelectorAll("img");
            // console.log(list);
            list.forEach((img) => {
              let parent = img.parentNode;
              let nextEle = parent.nextElementSibling;
              if (parent.querySelector("p")) {
                parent.querySelector("p").style.color = "#000080";
              } else if (nextEle.querySelector("p")) {
                nextEle.querySelector("p").style.color = "#000080";
              } else if (img.nextElementSibling) {
                img.nextElementSibling.style.color = "#000080";
              } else if (nextEle) {
                nextEle.style.color = "#000080";
              }
              // console.log(parent, nextSbiling);
            });
          });
        }
      );
    },
    viewTypeChange(type) {
      this.currentView = type;
    },
  },
};
</script>
<style>
body {
  background: #fff;
}

.en .detail-html p,
.en .detail-html section {
  line-height: 32px !important;
}

#detail .detail-html {
  text-align: justify;
}

.detail-html p,
.detail-html section {
  text-indent: 2em;

  text-justify: distribute-all-lines; /* 这行必加，兼容ie浏览器 */
  /* text-align-last: justify; */
}

.en .detail-html p,
.en .detail-html section {
  text-indent: 0;
}

.detail-html font {
  text-indent: 0 !important;
  /*display: block;*/
}

/*.detail-html strong font*/
</style>
<style lang="scss" scoped>
.mobile {
  .page {
    padding: 60px 10px !important;
  }
  .page-content {
    width: 100% !important;
    padding: 0 !important;
    .detail_title {
      font-size: 20px !important;
      line-height: 26px !important;
    }
  }
}
.en #detail .art-col .detail-html {
  padding: 0 fw(100vw, pc);
}

.en #detail .art-col .detail-info {
  padding: fh(12vh, pc) fw(100vw, pc);
}

#detail {
  position: relative;
  width: 100%;

  > .page {
    padding: fh(130vh, pc) fw(80vw, pc) 0 fw(80vw, pc);
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.13) 0%,
      #ffffff 100%
    );
    // height: fh(930vh, pc);
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      // background: url("../assets/images/djfb-bg.jpg") no-repeat;
      background-size: 100% auto;
      background-position: center 0;
    }

    ::v-deep .el-breadcrumb {
      display: block !important;
      // margin-left: fw(-40vw, pc);
      .el-breadcrumb__inner {
        font-weight: bold;
        color: rgba(104, 106, 103, 0.4) !important;
        font-size: fh(18vh, pc);

        &.is-link {
          cursor: pointer;
        }
      }

      .el-breadcrumb__item:nth-last-child(1) .el-breadcrumb__inner {
        color: #686a67 !important;
        font-weight: bold;
      }

      .el-icon-arrow-right:before {
        color: rgba(104, 106, 103, 0.4) !important;
        font-weight: bold;
      }
    }
  }

  .page-content {
    // padding: fh(20vh, pc) fw(0vw, pc) fh(40vh, pc) fw(0vw, pc);
    position: relative;
    width: fw(750vw, pc);
    margin: 0 auto;
  }
  .detail_content_box {
    width: 93%;
    min-height: 500px;
    margin: 0 auto;
    .detail_title {
      /// height: 32px;
      // white-space: nowrap;
      overflow-wrap: break-word;
      word-wrap: break-word;
      // color: rgba(0, 93, 176, 1);
      font-size: fh(32vh, pc);
      line-height: fh(50vh, pc);
      font-weight: 700;
      color: #333;
      padding-top: fh(40vh, pc);
    }
    .detail_time {
      width: 100%;
      margin-top: fh(20vh, pc);
      overflow-wrap: break-word;
      color: rgba(120, 120, 120, 1);
      font-size: fh(16vh, pc);
      font-weight: normal;
      text-align: center;
      white-space: nowrap;
      line-height: fh(24vh, pc);
      display: flex;
      justify-content: space-between;
    }
    .detail_content_info {
      border-top: solid 1px #ccc;
      border-bottom: solid 1px #ccc;
      margin-top: 20px;
      padding: 20px 0;
      line-height: 30px;
      overflow-wrap: break-word;
      color: rgba(42, 42, 42, 1);
      font-size: 18px;
      font-weight: normal;
      font-family: "SourceHanSansCN-Regular" !important;
    }
  }
}
</style>
